import { Button, Container, Flex, Paper, Stack, Text, Title } from "@mantine/core";

type ErrorContainerProps = {
  text: string;
  subtext?: string;
  status: number;
};

export function ErrorContainer({ text, status, subtext }: ErrorContainerProps) {
  return (
    <Container fluid mt="4rem">
      <Flex justify="center" align="center">
        <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
          <Stack ta="center">
            <Title order={1}>{status}</Title>
            <Title order={3}>{text}</Title>
            {subtext && <Text>{subtext}</Text>}
            <Button component="a" href="/">
              Zurück zur Homepage
            </Button>
          </Stack>
        </Paper>
      </Flex>
    </Container>
  );
}
